module.exports = __webpack_public_path__ + "img/Annotated_Desert_Tomb_Map.7ada7c94.png";